import ETLPipeline from "./ETLPipeline";
import AuthorityModel from "./AuthorityModel";
import ValidationEngine from "./ValidationEngine";
import AuditWorkflow from "./AuditWorkflow";
import ProcessingDashboard from "./ProcessingDashboard";

export default function RITAutomationPanel({ project }) {
  return (
    <div className="space-y-8">
      <ProcessingDashboard />
      <ETLPipeline />
      <AuthorityModel />
      <ValidationEngine />
      <AuditWorkflow />
    </div>
  );
}
